module.exports = __webpack_public_path__ + "img/adminsEgypt.7e67558a.svg";